import { FC } from 'react'
import theme from 'theme'

interface Props {
  isPinned?: boolean | null
}

const PinSvg: FC<Props> = ({ isPinned }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.25466 8.85113C5.99723 8.59546 6.04919 8.16582 6.36018 7.97895L6.80153 7.71374C7.38604 7.3625 8.13462 7.4544 8.61681 7.93659L12.7922 4.9743L12.5927 4.77478C12.1867 4.36877 12.1867 3.71052 12.5927 3.30451C12.9987 2.8985 13.657 2.8985 14.063 3.30451L16.6257 5.86725C17.0317 6.27326 17.0317 6.93151 16.6257 7.33752C16.2197 7.74353 15.5614 7.74353 15.1554 7.33752L14.9566 7.13864L11.9943 11.3141L11.9968 11.3166C12.4778 11.7976 12.5706 12.544 12.2219 13.1281L11.969 13.5517C11.7835 13.8624 11.3555 13.9164 11.0987 13.6614M6.25466 8.85113L11.0987 13.6614M6.25466 8.85113L7.99341 10.5777L9.4849 12.0588L11.0987 13.6614M4.86667 16.0667C4.42849 16.5048 3.63585 16.7241 3.06737 16.9708L3 17C3.24789 16.3704 3.3451 15.4196 3.82353 14.9412L6.5 12L8 13.5L4.86667 16.0667Z"
      stroke={theme.colors.dustyRoseGray}
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill={isPinned ? '#FFF' : undefined}
    />
  </svg>
)

export default PinSvg
